export default {"src":"/_next/static/media/manar.1ca0d0e6.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};